import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import 'vfonts/Roboto.css'
import naive from "naive-ui";
import i18n from '@/plugin/i18n' // 新增這一行
const app = createApp(App);
app.use(router);
app.use(naive);
app.use(i18n);
app.mount('#app');

// createApp(App).use(store).use(router).mount('#app')
